import { Textarea as ChakraTextarea, type TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';
import * as React from 'react';

/** Figma defines a single outline control — no size or variant axes on Text Area (1078:11889). */
export interface TextAreaProps extends Omit<ChakraTextareaProps, 'size' | 'variant'> {}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(props, ref) {
  return <ChakraTextarea ref={ref} variant="outline" {...props} />;
});
